import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { NotificationResult, NotificationStatus, UserNotificationService } from 'src/app/shared/services/user-notification.service';

@Component({
  selector: 'app-notify-users-dialog',
  templateUrl: './notify-users-dialog.component.html',
})
export class NotifyUsersDialogComponent implements OnInit {
  status: NotificationStatus | null = null;
  result: NotificationResult | null = null;
  sendError: string | null = null;
  isLoading = true;
  isSending = false;

  private readonly sendErrorMessages: Record<number, string> = {
    409: 'Already sent or operation in progress.',
    412: 'Reports not yet published.',
    422: 'No active recipients.',
  };

  constructor(
    private ref: DynamicDialogRef,
    private userNotificationService: UserNotificationService
  ) { }

  ngOnInit() {
    this.userNotificationService.getNotificationStatus().subscribe({
      next: (status) => {
        this.status = status;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  confirmSend() {
    this.isSending = true;
    this.userNotificationService.sendNotification().subscribe({
      next: (result) => {
        this.result = result;
        this.isSending = false;
      },
      error: (err) => {
        this.sendError = this.sendErrorMessages[err.status];
        this.isSending = false;
      }
    });
  }

  close() {
    this.ref.close();
  }
}
